import { UIComponent } from './UIComponent';

export interface ScreenConfig {
  id: string;           // Unique screen ID (e.g., 'combat', 'inventory')
  name: string;         // Display name for nav
  persistent: boolean;  // Keep DOM alive when hidden (true for combat)
  needsPhaser: boolean; // Show #battle-container instead of #screen-container
  hideNavBar?: boolean; // Hide the bottom nav bar while this screen is active
}

export abstract class Screen<TState = unknown> extends UIComponent<TState> {
  abstract readonly screenConfig: ScreenConfig;

  /** Called when this screen becomes active. Params come from navigate(). */
  onEnter(_params?: Record<string, unknown>): void {}

  /** Called when leaving this screen. */
  onLeave(): void {}

  /**
   * Create this screen's DOM inside #screen-container.
   * Only called once for persistent screens, every time for non-persistent.
   * Not used by needsPhaser screens (they use pre-existing DOM).
   */
  createDOM(_container: HTMLElement): void {}
}
